import {Map} from '../../utils/immutable'
import {UserState, UserStateMap} from './types'

export const initialState: UserStateMap = Map<UserState>({user: null, waitingListBookings: []})
